import React, {useContext} from 'react';
import OptionIcon from "../../assets/images/options-black.svg";
import FloContext from "../contexts/floContext";

export default function InstructionOptions(props: any) {
   const {step} = props;
   const {onNewInstruction, onDeleteInstruction}: any = useContext(FloContext);
   return(
       <div className="options-sec">
          <div className="options-icon flex" data-type="instruction">
             <div className="icon">
                <img src={OptionIcon} alt=""/>
             </div>
          </div>
          <ul className="options-list" id="instruction">
             <li onClick={() => onNewInstruction(step)}>Add step</li>
             <li onClick={() => onDeleteInstruction(step)} className="red-color">Delete</li>
          </ul>
       </div>
   )
}
